<template>
    <div class="fc-announcements" :class="getBannerPositionClass()">
        <Announcement
            v-for="(item, index) in items"
            :announcement="item"
            :index="index"
            :setInactiveAfterViewing />
    </div>
</template>

<script>
import Announcement from './Announcement.vue';

export default {
    data() {
        return {
            items:                    this.announcements,
            siteHeaderStyle:          null,
            announcementBannerHeight: null,
            siteHeaderHeight:         null,
            pageBannerMarginTop:      null,
            pageBannerHeightMod:      null,
        };
    },
    components: {Announcement},
    props:      {
        announcements:           {
            type:    Array,
            default: []
        },
        bannerPosition:          {
            type:    String,
            default: ""
        },
        setInactiveAfterViewing: {
            type:    Boolean,
            default: true
        }
    },

    mounted() {
        // console.log(this.announcements);
        // console.log(this.bannerPosition);
        // console.log(this.items);
        if (document.querySelector('body').classList.contains('transparent-site-header')) {
            this.siteHeaderStyle = 'transparent';
        } else if (document.querySelector('body').classList.contains('opaque-site-header')) {
            this.siteHeaderStyle = 'opaque';
        }

        this.stylePageBanner();

        window.addEventListener('resize', this.stylePageBanner);
        // console.log("AnnouncementsBanner.vue");
        // console.log(this.setInactiveAfterViewing);
    },

    methods: {
        stylePageBanner() {
            if (this.bannerPosition === 'above-header' || this.bannerPosition === 'below-header') {

                let siteHeader = document.getElementById('site-header');
                this.siteHeaderHeight = siteHeader.clientHeight;

                let pageBanner = document.getElementsByClassName('page-banner');
                // console.log(pageBanner)
                if (pageBanner) {

                    if (this.siteHeaderStyle === 'opaque') {
                        pageBanner[0].style.marginTop = this.siteHeaderHeight + 'px';
                    } else if (this.siteHeaderStyle === 'transparent') {
                        let pageBannerTransparentHeaderSpacingEl = document.getElementsByClassName('transparent-header-spacing');
                        // console.log(pageBannerTransparentHeaderSpacingEl)
                        pageBannerTransparentHeaderSpacingEl[0].style.height = this.siteHeaderHeight + 'px';
                        // adjust the height of the :after element
                        // might need to add an empty div to all the layouts
                    }
                }

                // adjust position of mega-menus.  Since they are fixed position from the top of the window.
                let megaMenus = document.querySelectorAll('.mega-menu .sub-menu-wrapper');
                let body = document.getElementsByTagName('body')[0];
                if (megaMenus) {
                    for(let i = 0; i < megaMenus.length; i++) {
                        if (body.classList.contains('admin-bar')) {
                            megaMenus[0].style.top = (this.siteHeaderHeight + 32) + 'px';
                        } else {
                            megaMenus[0].style.top = this.siteHeaderHeight + 'px';
                        }
                    }
                }
            }
        },
        getBannerPositionClass() {
            return (this.bannerPosition === 'above-header' || this.bannerPosition === 'below-header') ? 'inside-header' : 'lock-to-bottom';
        }
    }
}

</script>
